// extracted by mini-css-extract-plugin
module.exports = {"root":"image-card-module--root--2sQoa","centered":"image-card-module--centered--3CNqH","full":"image-card-module--full--3ZRZQ","inner":"image-card-module--inner--1QQDO"};